import apiClient from '@u/apiClient'

let base_errors = {}

export default {
  //region fetch
  async fetchCompanyIndex({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/company')
      .then(async (response) => {
        await commit('setCompanyList', response.data)
      })
      .catch(async (reason) => {
        console.error('fetchCompanyIndex', reason)
      })
  },
  async fetchCompanyByID({ commit }, id) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/company/${id}`)
      .then(async (response) => {
        commit('setCompany', response.data.company)
        commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchCompanyByID', reason)
      })
  },
  async fetchNewCompany({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=company')
      .then(async (response) => {
        await commit('setCompany', response.data.company)
        await commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewCompany', reason)
      })
  },
  async fetchCompanyActivitiesByCompanyID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/company/fetch-activities/${payload.company_id}`)
      .then(async (response) => {
        await commit('setCompanyActivity', response.data.activities)
      })
      .catch(async (reason) => {
        await console.error('fetchCompanyActivitiesByCompanyID', reason)
      })
  },
  //endregion

  //region store
  storeNewCompany({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .post('api/company', payload.company)
      .then((response) => response.data)
  },
  //endregion

  //region update
  updateCompany({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .put(`api/company/${payload.id}`, payload.company)
      .then((response) => response.data)
  },
  //endregion

  //region Peppol
  // Refusals (422 / 409 {message}) are toasted by apiClient.
  updateCompanyPeppol({ commit }, payload) {
    return apiClient
      .put(`api/company/${payload.id}/peppol`, {
        integrator: payload.integrator,
        send_mode: payload.send_mode
      })
      .then((response) => {
        commit('setCompanyPeppol', response.data.company)
        return response.data
      })
  },
  /** register / status / restart answer the same onboarding object. */
  registerCompanyToBcSolutions(_, payload) {
    return apiClient
      .post(`api/company/${payload.id}/peppol/bcsolutions/register`, {
        responsible_id: payload.responsible_id
      })
      .then((response) => response.data)
  },
  getBcSolutionsPeppolStatus(_, payload) {
    return apiClient
      .get(`api/company/${payload.id}/peppol/bcsolutions/status`)
      .then((response) => response.data)
  },
  restartBcSolutionsOnboarding(_, payload) {
    return apiClient
      .post(`api/company/${payload.id}/peppol/bcsolutions/restart`)
      .then((response) => response.data)
  },
  //endregion

  //region delete
  deleteCompanyById({ commit }, payload) {
    return apiClient
      .delete(`api/company/${payload.id}`)
      .then(async (response) => {
        await commit('setCompanyList', response.data)
        return response.data
      })
  },
  //endregion

  //region undoDelete
  undoDeleteCompanyById({ commit }, payload) {
    return apiClient
      .get(`api/company/undo-delete/${payload.id}`)
      .then(async (response) => {
        await commit('setCompanyList', response.data)
        return response.data
      })
  }
  //endregion
}
